import CONFIG from "../../config/index";
import * as Logger from "../../shared/utils/logger";
import { getAssessmentById } from "../../actions/assessment.action";

export const onAssessmentReportConnect = (socket, assessmentId) => {
    Logger.message("PROCESSED DATA SOCKET CONNECTED...")
    CONFIG.Store.dispatch(getAssessmentById(assessmentId, false))
    socket.emit('joinRoomRequest', { assessmentId })
}